exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-forms-select-option {\n  border: none;\n  padding: 0.5em;\n  color: #000 !important;\n  margin: 0.2em;\n  border-radius: 4px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./forms/select-option.less
// module id = 329
// module chunks = 0